"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkinPass = checkinPass;
exports.checkinPassWatcher = checkinPassWatcher;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _services = require("../../../services");
var _variables = require("../variables");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(checkinPassWatcher);
function checkinPass(_ref) {
  var payload = _ref.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, _response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.CheckinPassService.checkinPass, payload);
        case 3:
          response = _context.sent;
          _context.next = 6;
          return (0, _effects.put)({
            type: _variables.CHECKINPASS_SUCCESS,
            payload: response
          });
        case 6:
          _context.next = 13;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          _response = _context.t0.response;
          _context.next = 13;
          return (0, _effects.put)({
            type: _variables.CHECKINPASS_FAIL,
            payload: _response
          });
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  })();
}
function checkinPassWatcher() {
  return _regenerator["default"].wrap(function checkinPassWatcher$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        _context2.next = 2;
        return (0, _effects.takeLatest)(_variables.CHECKINPASS_REQUEST, checkinPass);
      case 2:
      case "end":
        return _context2.stop();
    }
  }, _marked);
}